<script setup lang="ts">
import type { StorePromoCoupon } from "~~/shared/types/store";
import { formatCouponReduction } from "~~/shared/utils/couponLabel";

const props = defineProps<{
  coupon: StorePromoCoupon;
}>();

const reductionLabel = computed(() => formatCouponReduction(props.coupon));
</script>

<template>
  <p class="promo-code">
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true"
    >
      <path
        d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
      />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
    <span
      ><strong>{{ reductionLabel }}</strong> z kodem:
      <strong class="promo-code__code">{{ coupon.code }}</strong></span
    >
  </p>
</template>

<style scoped>
.promo-code {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 10px 16px;
  background: var(--promo-pill-bg);
  border: var(--promo-pill-border);
  border-radius: 55px;
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--color-black, #151515);
  line-height: 1;
}

[data-brand="youlook"] .promo-code {
  background: transparent;
  padding: 0;
}

.promo-code strong {
  font-weight: 700;
}

.promo-code__code {
  color: var(--color-sale, #f83e3e);
  letter-spacing: 0.5px;
}
</style>
